(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('DayScheme', [DaySchemeFactoryFn]);


    function DaySchemeFactoryFn() {

        var DayScheme = function () {

            // default
            this.id = 0;
            this.dayEndTime = null;
            this.deleted = false;
            this.description = null;
            this.fK_User = null;
            this.fK_WeekScheme = null;
            this.fK_Country = null;
            this.weekday = null;
            this.date = null;

            // list of times
            this.times = [];

            // view model
            this.vmWeekday = null;
            this.vmCopyInProgress = false;
            this.vmPastePossible = false;
            // holiday object (if available)
            this.vmHoliday = null;

            // prepare for backend save
            function prepareForSave(weekschemeId) {
                var self = this;
                self.fK_WeekScheme = weekschemeId;

                // iterator over times
                self.times.forEach(function (time) {
                    if (time.hasOwnProperty('prepareForSave')) { time.prepareForSave(self.id, self); }
                });

                // just save times with valid agenda-label
                var times = [];
                var i = 0;
                var len = self.times.length;
                for (i = 0; i < len; i++) {
                    if (self.times[i].fK_AgendaLabel !== null) {
                        times.push(self.times[i]);
                    } //If
                } //for

                // replace
                self.times = times;

                delete self.highlight;
                delete self.vmWeekday;
                delete self.vmCopyInProgress;
                delete self.vmPastePossible;
                delete self.vmHoliday;
                delete self.hours;

            } // prepareForSave


            this.prepareForSave = prepareForSave;
        };


        // extend item
        DayScheme.prototype.extend = function (item) {
            var self = this;

            angular.extend(self, item);
        };


        return DayScheme;


    }
})();